<div class="wallet-type">
  @if (displayMode === 'payment') {
  <!-- Payment Mode Display -->
  @if (purchaseDetail?.page === 'topUp') {
  <div>
    <ion-card class="purchase-card">
      <p class="purchase-heading">{{ "add-card.Top up" | translate }}</p>
      <p class="purchase-content">{{ purchaseDetail?.real_name }}</p>
      @if (purchaseDetail?.line) {
      <p class="purchase-content">
        {{ purchaseDetail?.line }} {{ "add-card.Line(s)" | translate }}
      </p>
      }
    </ion-card>
  </div>
  }
  @if (purchaseDetail?.page === 'store') {
  <div>
    <ion-card class="purchase-card">
      @if (!checkoutDescription) {
      <p class="purchase-heading">{{ purchaseDetail?.selectedDay?.length * (purchaseDetail?.line + 1) }} {{
        "store-payment.Lines" | translate }}, {{ ('dynamic_value.'+ purchaseDetail?.real_name) | translate }}
      </p>
      }
      <ng-container>
        <p class="purchase-content">
          @if (checkoutDescription) {
          <span [innerHTML]="checkoutDescription | safeHtml | translate"></span>
          } @else {
          <span>{{ purchaseDetail?.line + 1 }} {{ (purchaseDetail?.line > 1 ? "store-payment.Lines" :
            "store-payment.line") |
            translate }} {{ ('dynamic_value.'+ purchaseDetail?.real_name) | translate }}</span>
          @for (day of purchaseDetail?.selectedDay; track day; let i = $index) {
          <span>
            @if (i > 0) {
            <span>, </span>
            }
            <span>{{ ('dynamic_value.'+(day | day) | translate) }}</span>
          </span>
          }
          @if (customOfferCashbackText) {
          <span>{{' + ' + customOfferCashbackText}}</span>
          }
          }
        </p>
      </ng-container>
      @if (purchaseDetail?.selectedDay?.length > 0 && purchaseDetail?.selectedDiscount?.type === 'subscription')
      {
      <p class="purchase-content">
        {{ "store-payment.flexible_membership" | translate }}
      </p>
      }
      @if (purchaseDetail?.selectedDay?.length > 0 && purchaseDetail?.selectedDiscount?.type ===
      'oneoff') {
      <p class="purchase-content">
        {{ purchaseDetail?.selectedDiscount?._title?.[selectedLanguage || "en"] ||
        purchaseDetail?.selectedDiscount?.title }}
      </p>
      }
      @if (purchaseDetail?.offers?.no_weeks > 1 && purchaseDetail?.offers?.no_weeks < 100) { <p
        class="purchase-content">
        {{ "add-card.For" | translate }}{{ ' ' + purchaseDetail?.offers?.no_weeks }}
        {{ "add-card.weeks" | translate }}
        </p>
        }
    </ion-card>
  </div>
  }
  @if (purchaseDetail?.page === 'offerDay') {
  <div>
    <h1 class="purchase-title">{{ "add-card.Purchase" | translate }}</h1>
    <ion-card class="purchase-card">
      <p class="purchase-heading">{{ purchaseDetail?.real_name }}</p>
      @for (desc of purchaseDetail?.offers?.description; track desc) {
      <p class="purchase-content">{{ desc }}</p>
      }
    </ion-card>
  </div>
  }
  @if (purchaseDetail?.page === 'offerOfDay' && purchaseDetail?.offers?.description?.length > 0) {
  <div>
    <h1 class="purchase-title">{{ "store-payment.Purchase" | translate }}</h1>
    <ion-card class="purchase-card">
      <p class="purchase-heading">{{ purchaseDetail?.real_name }}</p>
      @for (desc of purchaseDetail?.offers?.description; track desc) {
      <p class="purchase-content" [innerHTML]="desc | safeHtml"></p>
      }
    </ion-card>
  </div>
  }
  @if (purchaseDetail?.page === 'syndicate') {
  <div>
    <h1 class="purchase-title">{{ "add-card.Purchase" | translate }}</h1>
    <ion-card class="purchase-card">
      <p class="purchase-heading">{{ purchaseDetail?.real_name }}</p>
      @for (product of purchaseDetail?.products; track product) {
      <p class="purchase-content">
        {{ product?.product_name }} {{ product?.line_count }} {{ "add-card.Line(s)" | translate }}
      </p>
      }
      @for (selectedOffer of purchaseDetail?.selectedOffers; track selectedOffer) {
      <p class="purchase-heading purchase-offer">{{ selectedOffer?.title }}</p>
      <p class="purchase-content">{{ selectedOffer?.extract }}</p>
      }
    </ion-card>
  </div>
  }
  @if (purchaseDetail?.page === 'voucher') {
  <div>
    <h1 class="purchase-title">{{ "add-card.Purchase" | translate }}</h1>
    <ion-card class="purchase-card">
      <p class="purchase-heading">{{ purchaseDetail?.real_name }}</p>
      <p class="purchase-content">{{ purchaseDetail?.offers.description }}</p>
    </ion-card>
  </div>
  }
  }

  @if (displayMode === 'summary') {
  <!-- Summary Mode Display -->
  @if (purchaseDetail?.page === 'topUp') {
  <p class="brought-card-title">
    {{ "add-card.Top up" | translate }}
  </p>
  }
  @if (purchaseDetail?.page != 'topUp' && !checkoutDescription) {
  <p class="brought-card-title">
    {{ purchaseDetail?.real_name }} {{'add-card.Lines'|translate}}
  </p>
  }
  @if (purchaseDetail?.page === 'topUp' && purchaseDetail?.page !== 'syndicate') {
  <p class="brought-card-content">
    {{ purchaseDetail?.real_name }}
  </p>
  }
  @if (purchaseDetail?.page === 'syndicate') {
  <div>
    <p class="brought-card-content">{{ purchaseDetail?.real_name }}</p>
    @for (product of purchaseDetail?.products; track product) {
    <p class="line-heading">{{ product?.product_name }}</p>
    <p class="line-total">{{ product?.line_count }}{{'add-card.Line(s)'|translate}}</p>
    }
    @for (selectedOffer of purchaseDetail?.selectedOffers; track selectedOffer) {
    <p class="line-heading">{{ selectedOffer?.title }}</p>
    <p class="line-content">{{ selectedOffer?.extract }}</p>
    }
  </div>
  }
  @if (purchaseDetail?.page === 'offerDay') {
  <div>
    @for (desc of purchaseDetail?.offers?.description; track desc) {
    <p class="lines-total offerDay-desc">{{ desc }}</p>
    }
  </div>
  }
  @if (purchaseDetail?.page === 'store') {
  <div>
    @if (checkoutDescription) {
    <span [innerHTML]="checkoutDescription | safeHtml | translate"></span>
    } @else {
    @for (day of purchaseDetail?.selectedDay; track day) {
    <p class="lines-total offerDay-desc">{{ purchaseDetail?.line + 1 }} {{'add-card.lines on'|translate}}
      {{ ('dynamic_value.'+(day | day) | translate) }}
      @if (customOfferCashbackText) {
      <span>{{' + ' + customOfferCashbackText}}</span>
      }
    </p>
    }
    }
  </div>
  }
  @if (purchaseDetail?.page === 'voucher') {
  <div>
    <p class="line-content">{{ purchaseDetail?.offers.description }}</p>
  </div>
  }
  @if (purchaseDetail?.page === 'topUp') {
  <div></div>
  }
  <!-- UI for showing upsell options summary -->
  @if (upsellSummaryArray && upsellSummaryArray.length > 0) {
  <div class="upsell-checkout-summary">
    @for (addOn of upsellSummaryArray; track addOn) {
    @if (addOn.product_description === 'award' && addOn?.summary_content) {
    <div>
      <p class="brought-card-title">
        {{ "add-card.Top up" | translate }}
      </p>
      <p class="brought-card-content">
        {{ currencySymbol + addOn.summary_content?.amount?.[preferredCurrency] + ' ' +
        addOn.summary_content?.real_name + ' ' +
        addOn?.summary_content?.sub_label?.[selectedLanguage] }}
      </p>
    </div>
    }
    @if (addOn.product_description === 'offer' && addOn?.summary_content) {
    <div>
      <p class="brought-card-title">
        {{ addOn.summary_content?.real_name }} {{'add-card.Lines'|translate}}
      </p>
      @for (day of addOn.summary_content?.selected_day; track day) {
      <p class="lines-total offerDay-desc">{{ addOn.summary_content?.line + 1 }}
        {{'add-card.lines on'|translate}}
        {{ ('dynamic_value.'+(day | day) | translate) }}
      </p>
      }
    </div>
    }
    }
  </div>
  }
  }
</div>
